/**
 * @events
 * UploadModal:show
 * UploadModal:hide
 * UploadModal:submit
 * UploadModal:cancel
 */
import _ from 'lodash'
import View from 'view/view'

import ModalView from 'component/modal/modal'
import UploaderView from 'component/uploader/uploader'
import FilesCollection from 'component/uploader/collection/files'
import template from 'component/uploader/template/modal.tmpl'

export default View.extend({
    template,

    _subview: null,
    filesCollection: null,

    events: {
        'click .js-modal-cancel': '_onCancelClick',
        'click .js-modal-submit': '_onSubmitClick',
    },

    bubbleEvents: {
        'Modal:backdropClick': '_onCancelClick',
    },

    defaultOptions: {
        title: 'Share your photos',
    },

    initialize(options) {
        this.options = this.pickOptions(options, this.defaultOptions)

        this._subview = {
            modal: null,
        }

        this._initUploaderView = _.once(this._initUploaderView)

        this.filesCollection = new FilesCollection()

        this.listenTo(this.filesCollection, 'reset add remove change', _.debounce(this._onPhotosUpdate, 50))
    },

    show() {
        this.filesCollection.reset()

        this._subview.modal = this.initSubview(ModalView, {
            clone: false,
            content: this.render().el,
            fullHeight: true,
        })

        this.trigger('UploadModal:show')

        return this
    },

    hide() {
        if (!this._subview.modal) {
            return this
        }

        this._subview.modal.hide()
        this.destroySubviews(this._subview.modal)
        this.trigger('UploadModal:hide')

        this._subview.modal = null

        return this
    },

    _onCancelClick() {
        this.trigger('UploadModal:cancel', { filesCollection: this.filesCollection })
        this.hide()
    },

    _onSubmitClick() {
        this.trigger('UploadModal:submit', { filesCollection: this.filesCollection })
        this.hide()
    },

    _initUploaderView() {
        return this.initSubview(UploaderView, {
            className: 'u-spaceBottom',
            collection: this.filesCollection,
        })
    },

    _onPhotosUpdate() {
        if (!this._subview.modal) {
            this.render()
            return this
        }

        // save scroll position
        const scrollTopPosition = this.$('.js-modal-body').scrollTop()

        this.render()

        // restore scroll position
        this.$('.js-modal-body').scrollTop(scrollTopPosition)
        return this
    },

    render() {
        const isSubmitEnabled =
            this.filesCollection.length &&
            this.filesCollection.every((file) => file.has('id') || file.has('error')) &&
            this.filesCollection.some((file) => file.has('id'))

        this.$el.html(
            this.template({
                options: {
                    title: this.options.title,
                    isSubmitEnabled,
                },
            })
        )

        // Prevent uploader destroy/init on each render - new uploader instance will be created
        this._initUploaderView().render().$el.appendTo(this.$('.js-component-uploader'))

        if (this._subview.modal) {
            this._subview.modal.positionModal()
        }

        return this
    },
})
